exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.sidebar-sub-container-body[data-v-23244d4a] {\n  font-size: 0.8em !important;\n  line-height: 1.3;\n}", ""]);

// exports
